<template>
  <div class="follow-record-page">
    <div class="page-hero">
      <van-nav-bar title="跟进记录详情" left-arrow :border="false" @click-left="onClickLeft" />
      <div class="hero-copy">
        <div class="hero-title">跟进时间线</div>
        <div class="hero-desc">按时间查看当前会员的历史跟进节点</div>
      </div>
    </div>

    <div class="page-content">
      <div class="summary-card">
        <div class="summary-number">{{ memberInfos.length }}</div>
        <div class="summary-label">条跟进记录</div>
      </div>

      <div v-if="memberInfos.length > 0" class="timeline-list">
        <div v-for="(item, index) in memberInfos" :key="index" class="timeline-item">
          <div class="timeline-axis">
            <span class="timeline-dot"></span>
            <span class="timeline-line" v-if="index !== memberInfos.length - 1"></span>
          </div>
          <div class="timeline-card">
            <div class="timeline-top">
              <span class="timeline-badge" :class="{ cancel: item.followUpStatus === 4 }">{{ getStatusText(item) }}</span>
              <span class="timeline-time">{{ getCompleteTime(item.createOn) }}</span>
            </div>
            <div class="timeline-title">
              {{ item.followUpStatus === 4 ? `${item.operatorName} 取消跟进` : `${item.operatorName} 申请跟进` }}
            </div>
            <div class="timeline-desc">{{ getRecordDesc(item) }}</div>
          </div>
        </div>
      </div>

      <div v-else class="empty-card">暂无跟进记录</div>
    </div>
  </div>
</template>
<script>
import { getFollowUpProgressListByMemberId } from '../api/matchmakerInfo';

export default {
  data() {
    return {
      memberInfos: [],
      statusData: ['启动', '过程', '结果', '取消跟进', '互加微信', '了解中', '交往中', '已订婚', '已领证']
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getStatusText(item) {
      if (item.followUpStatus === 4) return '取消';
      return this.statusData[item.followUpStatus - 1] || '跟进';
    },
    getRecordDesc(item) {
      if (item.followUpStatus === 4) {
        return '该会员已被取消跟进。';
      }
      const parts = [];
      if (parseFloat(item.followUpStatus)) {
        parts.push(`跟进情况：${this.statusData[item.followUpStatus - 1] || '--'}`);
      }
      if (item.followUpDescription) {
        parts.push(`具体情况：${item.followUpDescription}`);
      }
      if (item.theOtherHalfName) {
        parts.push(`推荐对象：${item.theOtherHalfName}`);
      }
      if (item.theOtherHalfCompany) {
        parts.push(`推荐对象单位：${item.theOtherHalfCompany}`);
      }
      return parts.join('；') || '暂无补充说明';
    }
  },
  created() {
    const params = {
      memberInfoId: this.$route.params.id
    };
    getFollowUpProgressListByMemberId(params).then(item => {
      if (item && item.data) {
        this.memberInfos = item.data;
      }
    });
  }
};
</script>
<style lang="less" src='../style/followUpRecords.less' />



// WEBPACK FOOTER //
// src/views/followUpRecords.vue